import { canSendPrivateMessages } from '../../helpers/nodes/NodePolicyHelper';
import useCommunityPolicies from './useCommunityPolicies';
import type { QueryResult } from '@apollo/client';
import type {
  NodePoliciesQuery,
  NodePoliciesQueryVariables
} from '@aurora/shared-generated/types/graphql-types';

interface CanSendPrivateMessages {
  /**
   * Whether the user can send private messages, will be null while querying for the result.
   */
  canSendPrivateMessages: boolean | null;
}

/**
 * Whether the user can send private messages.
 *
 * @author Gaston Manzano
 */
export default function useCanSendPrivateMessages(): QueryResult<
  NodePoliciesQuery,
  Pick<NodePoliciesQueryVariables, 'useCanSendPrivateMessages'>
> &
  CanSendPrivateMessages {
  const queryResult = useCommunityPolicies(
    module,
    {
      useCanSendPrivateMessages: true
    },
    false
  );

  const { loading, data } = queryResult;

  return {
    ...queryResult,
    canSendPrivateMessages: loading ? null : canSendPrivateMessages(data?.coreNode)
  };
}
